import {
  FETCH_ID_VERIFICATION_STATUS_SUCCESS,
  FETCH_TERMS_STATUS_SUCCESS,
  RECEIVE_BUSINESS_VERIFICATION_DATA,
  UPDATE_IS_ID_VERIFYING,
  UPDATE_ON_BOARDING_PAGE_VIEWED,
} from '../constants/actionTypes';
import { getApplicationManagerNeedsToIdVerify } from '../utils/businessVerification';

const initState = () => ({
  isIdVerified: false,
  idVerifyingCompletedLink: null,
  idVerifyingPreviousLink: null,
  termsStatus: '',
  isOnboardingPageViewed: true,
  applicationManagerNeedsToIdv: false,
});

function updateIdVerificationStatus(state, payload) {
  return {
    ...state,
    isIdVerified: payload.isIdVerified,
  };
}

function updateIdVerifying(state, payload) {
  return {
    ...state,
    idVerifyingCompletedLink: payload.completedLink,
    idVerifyingPreviousLink: payload.previousLink,
  };
}

function updateTermsStatus(state, payload) {
  return {
    ...state,
    termsStatus: payload.termsStatus,
  };
}

function updateIsOnboardingPageViewed(state, payload) {
  return {
    ...state,
    isOnboardingPageViewed: payload.isOnboardingPageViewed,
  };
}

const landlord = (state = initState(), action = {}) => {
  const { type, payload } = action;

  switch (type) {
    case FETCH_ID_VERIFICATION_STATUS_SUCCESS:
      return updateIdVerificationStatus(state, payload);
    case UPDATE_IS_ID_VERIFYING:
      return updateIdVerifying(state, payload);
    case FETCH_TERMS_STATUS_SUCCESS:
      return updateTermsStatus(state, payload);
    case UPDATE_ON_BOARDING_PAGE_VIEWED:
      return updateIsOnboardingPageViewed(state, payload);
    case RECEIVE_BUSINESS_VERIFICATION_DATA:
      const applicationManagerNeedsToIdv = getApplicationManagerNeedsToIdVerify(action.data, action.userIdIrene);
      return {
        ...state,
        applicationManagerNeedsToIdv,
      };
    default:
      return state;
  }
};

export default landlord;
